import { Observable } from 'rxjs/Observable'

import { ModelRepositoryAdapter } from '../../../model-repository/model-repository-adapter'
import { ModelRepository } from '../../../model-repository/model-repository'

import { AnswerChoiceGroup } from '../../models'
import { AnswerChoiceService, LabelService } from '../'

export class AnswerChoiceGroupService extends ModelRepositoryAdapter<AnswerChoiceGroup> {
  public constructor(
    private _modelRepository: ModelRepository,
    private _answerChoiceService: AnswerChoiceService,
    private _labelService: LabelService
  ) {
    super(_modelRepository, AnswerChoiceGroup)
  }

  public save(answerChoiceGroup: AnswerChoiceGroup): Observable<AnswerChoiceGroup> {
    return super.save(answerChoiceGroup)
    .map((savedAnswerChoiceGroup) => {
      return Observable.forkJoin(
        ...answerChoiceGroup.answerChoices.map((answerChoice) => {
          answerChoice.answerChoiceGroup = savedAnswerChoiceGroup
          return this._answerChoiceService.save(answerChoice)
        }),
        ...answerChoiceGroup.labels.map((label) => {
          label.answerChoiceGroup = savedAnswerChoiceGroup
          return this._labelService.save(label)
        })
      ).map(() => savedAnswerChoiceGroup)
    }).flatMap((savedAnswerChoiceGroup) => savedAnswerChoiceGroup)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/services/answer-choice-group/answer-choice-group.service.ts